import { Button, Paragraph, TextInput, UserIcon } from "@datagame/ui";
import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { USER_UPDATE } from "../../../../graphql/mutations/UserMutations";
import { FieldWrapper } from "../../../shared/ui/FieldWrapper";
import { UserUpdateInput } from "../../../../gql/graphql";
import { ErrorMessage } from "../../../shared/ui/ErrorMessage";

import styles from "../Step1/Step1.module.scss";

export const Step3 = () => {
  const navigate = useNavigate();
  const { t: accountT } = useTranslation("account");
  const { t: commonT } = useTranslation("common");
  const [userUpdate, { error }] = useMutation(USER_UPDATE);

  const initialValues: UserUpdateInput = {
    firstName: "",
    lastName: "",
  };

  const handleSubmit = (values: UserUpdateInput) => {
    const variables = {
      data: {
        firstName: values.firstName,
        lastName: values.lastName,
      },
    };
    userUpdate({
      variables,
      onCompleted: () => {
        navigate("/", { replace: true });
      },
    });
  };

  const validationSchema = object({
    firstName: string().required(accountT("invitePage.step3.required") ?? undefined),
    lastName: string().required(accountT("invitePage.step3.required") ?? undefined),
  });

  return (
    <>
      <Paragraph color="secondary" className={styles.description}>
        {accountT("invitePage.step3.description")}
      </Paragraph>

      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ errors }) => (
          <Form className={styles.formWrapper}>
            {error && <ErrorMessage>{error.message}</ErrorMessage>}
            <div className={styles.fieldsWrapper}>
              <FieldWrapper label={commonT("form.firstName.label")} name="firstName">
                <Field
                  placeholder={commonT("form.firstName.placeholder")}
                  name="firstName"
                  as={TextInput}
                  icon={<UserIcon />}
                  error={errors.firstName}
                />
              </FieldWrapper>

              <FieldWrapper label={commonT("form.lastName.label")} name="lastName">
                <Field
                  placeholder={commonT("form.lastName.placeholder")}
                  name="lastName"
                  as={TextInput}
                  icon={<UserIcon />}
                  error={errors.lastName}
                />
              </FieldWrapper>
            </div>

            <Button className={styles.button} type="submit" size="large">
              {accountT("logMeIn")}
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};
